import { useMediaQuery, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

export const useWidth = () => {
    const theme = useTheme();
    const keys = [...theme.breakpoints.keys].reverse();
    return (
        keys.reduce((output, key) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const matches = useMediaQuery(theme.breakpoints.up(key));
            return !output && matches ? key : output;
        }, null) || 'xs'
    );
};

export const getBreakPointsValue = (valueSet, breakpoint) => {
    if (typeof valueSet === 'number') return valueSet;
    switch (breakpoint) {
        case 'xs':
            return valueSet.xs;
        case 'sm':
            return valueSet.sm || valueSet.xs;
        case 'md':
            return valueSet.md || valueSet.sm || valueSet.xs;
        case 'lg':
            return valueSet.lg || valueSet.md || valueSet.sm || valueSet.xs;
        default:
            return (
                valueSet.xl ||
                valueSet.lg ||
                valueSet.md ||
                valueSet.sm ||
                valueSet.xs
            );
    }
};

export const getFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    let k = 1024,
        dm = 2,
        sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const multiPropsFilter = (products, filters, stringKey = 'title') => {
    const filterKeys = Object.keys(filters);
    return products.filter((product) => {
        return filterKeys.every((key) => {
            if (filters[key].length === 0) return true;
            // Loops again if product[key] is an array (for material attribute).
            if (Array.isArray(product[key])) {
                return product[key].some((keyEle) =>
                    filters[key].includes(keyEle),
                );
            }
            if (filters[key]?.start || filters[key]?.end) {
                if (key === 'mrp') {
                    return (
                        product[key] >= filters[key].start &&
                        product[key] < filters[key].end
                    );
                } else {
                    const start = new Date(filters[key].start).getTime();
                    const end = new Date(filters[key].end).getTime();
                    const productDate = new Date(product[key]).getTime();

                    return productDate >= start && productDate <= end;
                }
            }
            if (key === stringKey) {
                return product[key]
                    .toLowerCase()
                    .includes(filters[key].toLowerCase());
            }
            return filters[key].includes(product[key]);
        });
    });
};

// 'intl' service singleton reference
let intl;

export function IntlGlobalProvider({ children }) {
    intl = useIntl();
    // Keep the 'intl' service reference
    return children;
}

export const appIntl = () => {
    return intl;
};

export const userInfo = (token) => {
    let isAuthenticated = false;
    let service_id = null;
    let user_id = null;
    let username = null;
    let api_key = null;
    if (token) {
        try {
            const decodedToken = jwtDecode(token);
            isAuthenticated = true;
            service_id = decodedToken.service_id || null;
            api_key = decodedToken.api_key || null;
            user_id = decodedToken.user_id || null;
            username = decodedToken.username || null;
        } catch (error) {
            console.error('Failed to decode token:', error);
        }
    }

    return {
        isAuthenticated,
        user: {
            id: user_id,
            uid: user_id,
            displayName: username,
            email: username,
            photoURL:
                'https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.vectorstock.com%2Froyalty-free-vector%2Fhipster-avatar-image-vector-19639289&psig=AOvVaw2Ng9847sQGHa55EvaxT-Vj&ust=1716277854207000&source=images&cd=vfe&opi=89978449&ved=0CA8QjRxqFwoTCIC0-7Dfm4YDFQAAAAAdAAAAABAE',
            service_id,
            api_key,
        },
        access_token: token,
    };
};
